<template>
  <div class="wlx-site-manager-wrapper wlx-user-manager">
    <header class="site-manager-head-con" style="padding-top:20px;">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="name" placeholder="请输入名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getExamTimeList()">搜索</el-button>
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="openDialog()">添加</el-button>
          <!-- <el-button type="primary"  @click="goback()">返回</el-button> -->
          <el-button type="primary" icon="wl-icon-fanhui" @click="fanhui()">返回</el-button>
        </el-form-item>
      </el-form>
    </header>

    <el-table :data="examTimeList">
         <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="Name" label="名称" ></el-table-column>
          <el-table-column prop="StartTime" label="考试开始时间"></el-table-column>
          <el-table-column prop="EndTime" label="报名结束时间"></el-table-column>
          <!-- <el-table-column prop="OneExmaTime" label="基础考核时间"></el-table-column>
          <el-table-column prop="TwoExmaTime" label="综合考核时间"></el-table-column>
          <el-table-column prop="ThreeExmaTime" label="线下考核时间" ></el-table-column> -->
          <el-table-column prop="ThreeExmaTime" label="等级" >
            <template slot-scope="scope">
              <span v-if="scope.row.IsCJ==1">初级、</span>
              <span v-if="scope.row.IsZj==1">中级、</span>
              <span v-if="scope.row.IsGJ==1">高级、</span>
            </template>
          </el-table-column>
          <el-table-column prop="Number" label="报名人数" ></el-table-column>
          <el-table-column prop="Number" label="是否展示" >
            <template slot-scope="scope">
              <span v-if="scope.row.IsShow==1">展示</span>
              <span v-else>不展示</span>
            </template>
          </el-table-column>
          <el-table-column prop="Number" label="是否禁用" >
            <template slot-scope="scope">
              <span v-if="scope.row.IsProhibit==0">启用</span>
              <span v-else>禁用</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <!-- <el-button icon="wl-icon-chakan" size="mini" type="primary" @click="goLook(scope.row.id)"></el-button> -->
              <el-button icon="el-icon-edit" size="mini" type="primary" @click="editDialog(scope.row)"></el-button>
              <el-button icon="el-icon-delete" size="mini" type="danger" @click="deleteExamTime(scope.row.Id)"></el-button>
            </template>
          </el-table-column>
    </el-table>

    <div class="u-page-con">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="onPageChangeHandler"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100,200,500,1000]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        v-show="totalCount>0"
        style="text-align: center;"
      ></el-pagination>
    </div>
    
    <el-dialog
      :title="tisi"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleClose">
      
      <el-form ref="form" label-width="120px">
          <el-form-item label="批次名称" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <!-- <el-form-item label="绑定考试" prop="examId">
            <el-select v-model="form.examId" filterable placeholder="请选择" clearable >
              <el-option
                v-for="item in examList"
                :key="item.Id"
                :label="item.ExamTitle"
                :value="item.Id"
                :disabled="item.SignState==2">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="考试开始时间" prop="startTime">
            <el-date-picker v-model="form.startTime" type="date" placeholder="选择开始时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="报名结束时间" prop="endTime">
            <el-date-picker v-model="form.endTime" type="date" placeholder="选择结束时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="基础考核安排" prop="oneExmaTime">
            <el-input v-model="form.oneExmaTime"></el-input>
          </el-form-item>
          <el-form-item label="综合考核安排" prop="twoExmaTime">
            <el-input v-model="form.twoExmaTime"></el-input>
          </el-form-item>
          <el-form-item label="线下考核安排" prop="threeExmaTime">
            <el-input v-model="form.threeExmaTime"></el-input>
          </el-form-item>
          <el-form-item label="是否是初级" prop="isCJ">
            <el-radio-group v-model="form.isCJ" @change="cjChange">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
            <label style="margin-left:50px;" v-if="form.isCJ==1">绑定考试: </label>
            <el-select v-model="form.cjexamId" filterable placeholder="请选择" clearable size="mini" v-if="form.isCJ==1">
              <el-option
                v-for="item in cjexamList"
                :key="item.Id"
                :label="item.ExamTitle"
                :value="item.Id"
                :disabled="item.SignState==2">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否是中级" prop="isZj">
            <el-radio-group v-model="form.isZj" @change="zjChange">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
            <label style="margin-left:50px;" v-if="form.isZj==1">绑定考试: </label>
            <el-select v-model="form.zjexamId" filterable placeholder="请选择" clearable size="mini" v-if="form.isZj==1">
              <el-option
                v-for="item in zjexamList"
                :key="item.Id"
                :label="item.ExamTitle"
                :value="item.Id"
                :disabled="item.SignState==2">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否是高级" prop="isGJ">
            <el-radio-group v-model="form.isGJ" @change="gjChange">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
            <label style="margin-left:50px;" v-if="form.isGJ==1">绑定考试: </label>
            <el-select v-model="form.gjexamId" filterable placeholder="请选择" clearable size="mini" v-if="form.isGJ==1">
              <el-option
                v-for="item in gjexamList"
                :key="item.Id"
                :label="item.ExamTitle"
                :value="item.Id"
                :disabled="item.SignState==2">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="具体安排">
            <textarea v-model="form.content"></textarea>
          </el-form-item> -->
          <el-form-item label="是否展示">
            <el-radio-group v-model="form.isShow">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否禁用">
            <el-radio-group v-model="form.isProhibit">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addOrEditExamTime()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      totalCount: 0,
      examTimeList:[],
      name:"",
      committeeType:'',
      isCommittee:'',
      // 新增/编辑
      dialogVisible:false,
      tisi:"",
      form:{
        id:'',
        name:'',
        cjexamId:'',
        zjexamId:'',
        gjexamId:'',
        startTime:'',
        endTime:'',
        oneExmaTime:'08:30-10:00',
        twoExmaTime:'10:30-11:30',
        threeExmaTime:'14:00-18:00',
        isCJ:0,
        isZj:0,
        isGJ:0,
        content:'',
        isShow:1,
        isProhibit:0
      },
      cjexamList:[],
      zjexamList:[],
      gjexamList:[]
    };
  },
  components: {},
 
  created() {
    this.getExamTimeList();
    this.getExamList();
  },
  props:{
    certificateId: {
      type: String,
      default: ""
    }
  },
  methods: {
    // goback(){
    //   this.$router.go(-1);
    // },
    cjChange(){
      this.form.cjexamId = "";
    },
    zjChange(){
      this.form.zjexamId = "";
    },
    gjChange(){
      this.form.gjexamId = "";
    },
    getExamList(){
      var that = this;
      this.$http
        .post("/api/XOrg/ExamTime/getExamList")
        .then(rst => {
          that.cjexamList = rst.cjlist;
          that.zjexamList = rst.zjlist;
          that.gjexamList = rst.gjlist;
        });
    },
    handleSelectionChange() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getExamTimeList();
    },
    onPageChangeHandler(val) {
      this.page = val;
      this.getExamTimeList();
    },
    getExamTimeList() {
      var that = this;
      this.$http
        .post("/api/XOrg/ExamTime/getExamTimeList", {
          name :that.name,
          certificateId:that.certificateId,
          PageSize: that.pageSize,
          page: that.page
        })
        .then(rst => {
          that.examTimeList = rst.list;
          that.page = rst.pagination.pageIndex;
          that.pageSize = rst.pagination.pageSize;
          that.totalCount = rst.pagination.totalCount;
        });
    },
    openDialog(){
      this.tisi = "添加";
      this.dialogVisible = true;
      this.form.id = "";
      this.form.name = "";
      this.form.cjexamId = "";
      this.form.zjexamId = "";
      this.form.gjexamId = "";
      this.form.startTime = "";
      this.form.endTime = "";
      this.form.oneExmaTime = "08:30-10:00";
      this.form.twoExmaTime = "10:30-11:30";
      this.form.threeExmaTime = "14:00-18:00";
      this.form.isCJ = 0;
      this.form.isZj = 0;
      this.form.isGJ = 0;
      this.form.content = "";
      this.form.isShow = 1;
      this.form.isProhibit = 0;
    },
    editDialog(row){
      this.tisi = "修改";
      this.dialogVisible = true;
      this.form.id = row.Id;
      this.form.name = row.Name;
      this.form.startTime = row.StartTime;
      this.form.endTime = row.EndTime;
      this.form.oneExmaTime = row.OneExmaTime;
      this.form.twoExmaTime = row.TwoExmaTime;
      this.form.threeExmaTime = row.ThreeExmaTime;
      this.form.isCJ = row.IsCJ;
      this.form.isZj = row.IsZj;
      this.form.isGJ = row.IsGJ;
      this.form.content = row.Content;
      this.form.cjexamId = row.CJExamId;
      this.form.zjexamId = row.ZJExamId;
      this.form.gjexamId = row.GJExamId;
      this.form.isShow = row.IsShow;
      this.form.isProhibit = row.IsProhibit;
    },
    handleClose(){
      this.dialogVisible = false;
    },
    addOrEditExamTime(){
      var that = this;
      this.$http
        .post("/api/XOrg/ExamTime/addOrEditExamTime", {
          id :that.form.id,
          Name: that.form.name,
          cjexamId: that.form.cjexamId,
          zjexamId: that.form.zjexamId,
          gjexamId: that.form.gjexamId,
          StartTime: that.form.startTime,
          EndTime:that.form.endTime,
          OneExmaTime:that.form.oneExmaTime,
          TwoExmaTime:that.form.twoExmaTime,
          ThreeExmaTime:that.form.threeExmaTime,
          IsCJ:that.form.isCJ,
          IsZj:that.form.isZj,
          IsGJ:that.form.isGJ,
          Content:that.form.content,
          IsShow:that.form.isShow,
          IsProhibit:that.form.isProhibit,
          certificateId: that.certificateId
        })
        .then(rst => {
          if(rst.code > 0){
            that.page = 1;
            that.getExamTimeList();
            that.dialogVisible = false;
            that.$message.success(rst.msg);
          }else{
            that.$message.warning(rst.msg);
          }
        });
    },
    deleteExamTime(id){
      var that = this;
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http
            .post("/api/XOrg/ExamTime/deleteExamTime", {
              ids: id
            })
            .then(rst => {
              if(rst.code > 0){
                that.page = 1;
                that.getExamTimeList();
                that.$message.success(rst.msg);
              }else{
                that.$message.warning(rst.msg);
              }
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    fanhui(){
      this.$router.push({
        name: "examDeclareManager"
      });
    }
  }
};
</script>
<style lang="scss">
.yk-wrap-fixed{
    .el-input--suffix .el-input__inner {
      padding-right: 30px;
      height: 34px;
  }
    .wl-pagination-text{ 
      text-align: center;
      margin-top: 30px;
    }
    .site-manager-head-con{
      text-align: right;
    }
    .el-form-item__content{
      .el-button{
        padding: 8px 15px;
      }
    }
  }
  .wlx-site-manager-wrapper{
      .export-button-a{
        padding: 9px 15px;
        background-color: #409EFF;
        font-size: 12px;
        border-radius: 3px;
      }
  }
  .wlx-user-manager{
      padding-left: 30px;
  }
</style>
